import { render, staticRenderFns } from "./TravelManager.vue?vue&type=template&id=12dc55a4&scoped=true"
import script from "./TravelManager.vue?vue&type=script&lang=js"
export * from "./TravelManager.vue?vue&type=script&lang=js"
import style0 from "./TravelManager.vue?vue&type=style&index=0&id=12dc55a4&prod&scoped=true&lang=css"
import style1 from "./TravelManager.vue?vue&type=style&index=1&id=12dc55a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc55a4",
  null
  
)

export default component.exports